module.exports = __webpack_public_path__ + "static/media/tab.2129afa0.png";